import { useContext } from 'react';
import { Route, Routes as SwitchRoutes, Navigate } from 'react-router-dom'
import { AuthContext } from '../contexts/auth';
import { useToken } from '../hooks/useToken';
import { Files } from '../pages/admin/files';
import { AdminLanding, Companies, Drivers, Kanban, NotFound, Reports, SignIn, Users } from '../pages';
import { Trackers } from '../pages/admin/trackers';
import { VehiclesAdmin } from '../pages/admin/vehicleAdmin';
import { CardsViewAdmin } from '../pages/admin/cardsAdmin';
import { ReportsAdmin } from '../pages/admin/reportsAdmin';
import { CardsView } from '../pages/nonAdmin/cards';
import { Vehicles } from '../pages/nonAdmin/vehicles';
import { GridDetails } from '../pages/grid';
import { MessageRS232 } from '../pages/admin/reportsAdmin/messageRS232';
import { TrackerOTA } from '../pages/admin/ota';
import { Users2 } from '../pages/nonAdmin/users';

export const Routes = () => {
    const [token, { hasToken }] = useToken();
    const { isAdmin, operations } = useContext(AuthContext);
    const userType = isAdmin();
    const operationsUser = operations();
    sessionStorage.setItem("typeOperationUser", operationsUser)
    return hasToken() ? (
        /* The code block you provided is a conditional rendering statement in JSX. It checks the value
        of the `isAdmin` variable and renders different sets of routes based on its value. */
        userType === "SystemAdmin" ? (
            <SwitchRoutes>
                <Route exact path="/" element={<CardsViewAdmin />} />
                <Route exact path="/kanban" element={<AdminLanding />} />
                <Route exact path="/users" element={<Users />} />
                <Route exact path="/companies" element={<Companies />} />
                <Route exact path="/vehicles" element={<VehiclesAdmin />} />
                <Route exact path="/drivers" element={<Drivers />} />
                <Route exact path="/reports" element={<ReportsAdmin />} />
                <Route exact path="/suntecRS232" element={<MessageRS232 />} />
                <Route exact path="/trackers" element={<Trackers />} />
                <Route exact path="/files" element={<Files />} />
                <Route exact path='/dataGrid' element={<GridDetails />} />
                <Route exact path='/trackersOta' element={<TrackerOTA />} />
                <Route exact path="/404" element={<NotFound />} />

                <Route exact path="/login" element={<Navigate to='/' />} />
            </SwitchRoutes>
        )
            :
            operationsUser === "GRANJAS" && userType !== "Administrador" ?
                (
                    <SwitchRoutes>
                        <Route exact path="/" element={<Kanban />} />
                        <Route exact path="/vehicles" element={<Vehicles />} />
                        <Route exact path="/reports" element={<Reports />} />
                        <Route exact path="/404" element={<NotFound />} />

                        <Route exact path="/login" element={<Navigate to='/' />} />
                    </SwitchRoutes>
                )
            :
            userType === "Administrador" ? (
                <SwitchRoutes>
                    <Route exact path="/" element={<GridDetails />} />
                    <Route exact path="/kanban" element={<Kanban />} />
                    <Route exact path="/cards" element={<CardsView />} />
                    <Route exact path="/vehicles" element={<Vehicles />} />
                    <Route exact path="/users" element={<Users2 />} />
                    <Route exact path="/drivers" element={<Drivers />} />
                    <Route exact path="/reports" element={<Reports />} />
                    <Route exact path="/404" element={<NotFound />} />

                    <Route exact path="/login" element={<Navigate to='/' />} />
                </SwitchRoutes>
            ) :
                (
                    <SwitchRoutes>
                        <Route exact path="/" element={<GridDetails />} />
                        <Route exact path="/kanban" element={<Kanban />} />
                        <Route exact path="/cards" element={<CardsView />} />
                        <Route exact path="/vehicles" element={<Vehicles />} />
                        <Route exact path="/drivers" element={<Drivers />} />
                        <Route exact path="/reports" element={<Reports />} />
                        <Route exact path="/404" element={<NotFound />} />

                        <Route exact path="/login" element={<Navigate to='/' />} />
                    </SwitchRoutes>
                )
    ) : (
        <SwitchRoutes>
            <Route exact path="/login" element={<SignIn />} />
            <Route exact path="*" element={<Navigate to='/login' />} />
        </SwitchRoutes >
    );
}